import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

const TextFieldComponent = React.memo(
  ({ type, onChange, size, variant, maxLength, ...rest }: TextFieldProps & { maxLength?: number }) => {
    return (
      <TextField
        variant={variant || 'outlined'}
        type={type || 'text'}
        size={size || 'small'}
        onChange={onChange}
        inputProps={{
          maxLength: maxLength === -1 ? undefined : maxLength || 200,
        }}
        {...rest}
      />
    );
  },
);

TextFieldComponent.displayName = 'TextFieldComponent';

export default TextFieldComponent;
